import { EMPTY } from "rxjs";
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatusReportService {
  constructor(private location: Location, private http: HttpClient) { }

  getData(customerID: string) {
    const currentUrl = this.location.path(true);
    const findAPIKey = currentUrl.match(/(&|\?)apiKey=(.*)(&|$)/);
    if (!findAPIKey || !findAPIKey[2]) return EMPTY;

    const url = `/api/${customerID}/statusreportdata?apiKey=${findAPIKey[2]}`;
    return this.http.post(url, null);
  }
}
